"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _icon_helpers = require("./icon_helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ForwardArrow = function ForwardArrow(_ref) {
  var width = _ref.width,
    strokeWidth = _ref.strokeWidth,
    color = _ref.color,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: strokeWidth,
    fill: color,
    stroke: color,
    d: "M12.304 10l-6.13 6.485c-.285.3-.27.775.03 1.06.3.285.775.27 1.06-.03L14.368 10 7.264 2.485c-.285-.3-.76-.315-1.06-.03-.3.285-.315.76-.03 1.06L12.304 10z"
  }));
};
ForwardArrow.defaultProps = _icon_helpers.defaultArrowProps;
var _default = ForwardArrow;
exports["default"] = _default;